export class CartItem {
  constructor(
    public readonly id: string,
    public readonly productEntityType: string,
    public readonly productEntityId: string,
    public quantity: number,
    public readonly productData: {
      name: string;
      price: number;
      image: string | null;
      isDigital: boolean;
    },
    public readonly isPurchable: boolean,
    public subtotal: number
  ) {}

  updateQuantity(newQuantity: number): void {
    if (this.productData.isDigital) {
      this.quantity = 1;
      return;
    }
    if (newQuantity < 1) throw new Error('Quantity must be at least 1');
    this.quantity = newQuantity;
  }

  get formattedSubtotal(): string {
    return `$${this.subtotal.toFixed(2)}`;
  }
}
